/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TutoraiUsage200,
  GetApiV1TutoraiUsage401,
  GetApiV1TutoraiUsage500,
  GetApiV1TutoraiUsageQueryParams,
  GetApiV1TutoraiUsageQueryResponse,
} from "../../types/tutorAIUsageController/GetApiV1TutoraiUsage.ts";
import { tutorAITokenUsageReportViewModelSchema } from "../tutorAITokenUsageReportViewModelSchema.ts";

export const getApiV1TutoraiUsageQueryParamsSchema = z
  .object({
    personId: z.optional(z.coerce.number().int()),
    start: z.optional(z.string().date()),
    end: z.optional(z.string().date()),
  })
  .optional() as unknown as ToZod<GetApiV1TutoraiUsageQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TutoraiUsage200Schema = z.lazy(
  () => tutorAITokenUsageReportViewModelSchema,
) as unknown as ToZod<GetApiV1TutoraiUsage200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TutoraiUsage401Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiUsage401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TutoraiUsage500Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiUsage500>;

export const getApiV1TutoraiUsageQueryResponseSchema = z.lazy(
  () => getApiV1TutoraiUsage200Schema,
) as unknown as ToZod<GetApiV1TutoraiUsageQueryResponse>;
